export const CONTACT_SECURITY_CONFIG = {
  // Configuración general de seguridad
  SECURITY: {
    // Score mínimo para considerar al usuario como humano (75%)
    MIN_VERIFICATION_SCORE: 75,
    
    // Número mínimo de verificaciones que deben pasar
    MIN_VERIFICATION_CHECKS: 3,
    
    // Tiempo máximo para completar la verificación (en ms)
    VERIFICATION_TIMEOUT: 10000,
  },

  // Configuración de verificaciones
  VERIFICATIONS: {
    // Verificación de interacción del usuario
    USER_INTERACTION: {
      // Tiempo mínimo que el usuario debe estar en la página antes de la verificación
      MIN_PAGE_TIME: 1000,
      // Probabilidad de pasar la verificación (para casos edge)
      PASS_PROBABILITY: 0.9,
    },

    // Verificaciones del navegador
    BROWSER_CHECKS: {
      // Número mínimo de verificaciones del navegador que deben pasar
      MIN_PASSED_CHECKS: 6,
      // Verificaciones totales disponibles
      TOTAL_CHECKS: 8,
      // Longitud mínima del user agent
      MIN_USER_AGENT_LENGTH: 10,
      // Resolución mínima de pantalla
      MIN_SCREEN_WIDTH: 100,
      MIN_SCREEN_HEIGHT: 100,
    },

    // Verificación basada en tiempo
    TIME_BASED: {
      // Delay para simular análisis de comportamiento
      ANALYSIS_DELAY: 500,
      // Probabilidad de pasar la verificación
      PASS_PROBABILITY: 0.9,
    },

    // Análisis de comportamiento
    BEHAVIOR_ANALYSIS: {
      // Número mínimo de comportamientos que deben pasar
      MIN_PASSED_BEHAVIORS: 3,
      // Comportamientos totales verificados
      TOTAL_BEHAVIORS: 4,
      // Tiempo mínimo en la página para considerar comportamiento válido
      MIN_PAGE_TIME: 1000,
    },
  },

  // Configuración de la interfaz de usuario
  UI: {
    // Delays para la experiencia del usuario
    DELAYS: {
      // Tiempo antes de mostrar el modal de verificación
      MODAL_DISPLAY: 100,
      // Tiempo para mostrar el mensaje de éxito
      SUCCESS_DISPLAY: 1000,
      // Tiempo para cerrar automáticamente el modal
      AUTO_CLOSE: 2000,
    },

    // Mensajes personalizables
    MESSAGES: {
      VERIFICATION_TITLE: 'Verificación de Seguridad',
      VERIFICATION_DESCRIPTION: 'Verificando que eres un usuario humano...',
      SUCCESS_TITLE: '¡Verificación Exitosa!',
      SUCCESS_PHONE: 'Redirigiendo a la llamada...',
      SUCCESS_EMAIL: 'Redirigiendo al correo...',
      FAILED_TITLE: 'Verificación Fallida',
      FAILED_DESCRIPTION: 'No se pudo verificar que seas un usuario humano. Por favor, intenta de nuevo.',
      RETRY_BUTTON: 'Reintentar',
      CLOSE_BUTTON: 'Cerrar',
    },

    // Estilos y clases CSS
    STYLES: {
      MODAL_BACKGROUND: 'fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50',
      MODAL_CONTENT: 'bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl',
      PROGRESS_BAR: 'bg-neuro-blue h-2 rounded-full transition-all duration-300',
      SUCCESS_ICON: 'h-16 w-16 text-green-500 mx-auto',
      FAILED_ICON: 'h-16 w-16 text-red-500 mx-auto',
      RETRY_BUTTON: 'bg-neuro-blue text-white px-4 py-2 rounded-md hover:bg-opacity-90 transition-colors',
    },
  },

  // Configuración de logging y monitoreo
  MONITORING: {
    // Habilitar logging de verificaciones
    ENABLE_LOGGING: true,
    // Nivel de logging (debug, info, warn, error)
    LOG_LEVEL: 'info',
    // Capturar métricas de verificación
    CAPTURE_METRICS: true,
    // Almacenar intentos fallidos
    STORE_FAILED_ATTEMPTS: true,
  },

  // Configuración de rate limiting
  RATE_LIMITING: {
    // Habilitar rate limiting
    ENABLED: true,
    // Máximo de intentos por IP por hora
    MAX_ATTEMPTS_PER_HOUR: 10,
    // Tiempo de bloqueo después de exceder el límite (en ms)
    BLOCK_DURATION: 3600000, // 1 hora
  },
};

// Tipos para la configuración
export interface ContactSecurityConfig {
  SECURITY: {
    MIN_VERIFICATION_SCORE: number;
    MIN_VERIFICATION_CHECKS: number;
    VERIFICATION_TIMEOUT: number;
  };
  VERIFICATIONS: {
    USER_INTERACTION: {
      MIN_PAGE_TIME: number;
      PASS_PROBABILITY: number;
    };
    BROWSER_CHECKS: {
      MIN_PASSED_CHECKS: number;
      TOTAL_CHECKS: number;
      MIN_USER_AGENT_LENGTH: number;
      MIN_SCREEN_WIDTH: number;
      MIN_SCREEN_HEIGHT: number;
    };
    TIME_BASED: {
      ANALYSIS_DELAY: number;
      PASS_PROBABILITY: number;
    };
    BEHAVIOR_ANALYSIS: {
      MIN_PASSED_BEHAVIORS: number;
      TOTAL_BEHAVIORS: number;
      MIN_PAGE_TIME: number;
    };
  };
  UI: {
    DELAYS: {
      MODAL_DISPLAY: number;
      SUCCESS_DISPLAY: number;
      AUTO_CLOSE: number;
    };
    MESSAGES: {
      VERIFICATION_TITLE: string;
      VERIFICATION_DESCRIPTION: string;
      SUCCESS_TITLE: string;
      SUCCESS_PHONE: string;
      SUCCESS_EMAIL: string;
      FAILED_TITLE: string;
      FAILED_DESCRIPTION: string;
      RETRY_BUTTON: string;
      CLOSE_BUTTON: string;
    };
    STYLES: {
      MODAL_BACKGROUND: string;
      MODAL_CONTENT: string;
      PROGRESS_BAR: string;
      SUCCESS_ICON: string;
      FAILED_ICON: string;
      RETRY_BUTTON: string;
    };
  };
  MONITORING: {
    ENABLE_LOGGING: boolean;
    LOG_LEVEL: string;
    CAPTURE_METRICS: boolean;
    STORE_FAILED_ATTEMPTS: boolean;
  };
  RATE_LIMITING: {
    ENABLED: boolean;
    MAX_ATTEMPTS_PER_HOUR: number;
    BLOCK_DURATION: number;
  };
}
